import { request } from "@lib/http";
import { saveState, removeState } from "@lib/localStorage";

/* Annonce */

// load annonce details
export async function loadAnnonceDetails(id) {
    try {
        const response = await request('get', `/offer/${id}`, {});
        if (response.success) {           
            const { success, data } = response;        
            return {
                success,
                data: data.offer
            }
        }   
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};

// load annonces
export async function loadAnnonces(query) {
    try {
        const response = await request('get', query, {});
        if (response.success) return response  
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};

// add annonce
export async function addAnnonce(data) {
    try {
        const response = await request('post', `/offer`, {}, data);
        console.log('response: ', response)
        if (response.success) return response;     
        
    } catch (err) {
        return err.response.data
    }
};

// edit annonce
export async function editAnnonce(data, id) {
    try {
        const response = await request('put', `/offer/${id}`, {}, data);
        if (response.success) return response
        
    } catch (err) {
        return err.response.data
    }
};

// delete annonce
export async function deleteAnnonce(id) {
    try {
        const response = await request('delete', `/offer/${id}`, {});
        if (response.success) return response
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};

// applicants listing
export async function applicantsListing(page, id) {
    try {
        const response = await request('get', `/offer/${id}/applicants?page=${page}`, {});
        if (response.success) return response;
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};


/* Favourite */

// load favourite candidates
export async function load_favourite_candidates(query) {
    try {
        const response = await request('get', query, {});
        if (response.success) {           
            const { success, data } = response;        
            return {
                success,
                data: data.persons
            }
        }   
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};

// like candidate
export async function like_candidate(data) {
    try {
        console.log('id ', data)
        const response = await request('post', '/person/like', {}, data);
        if (response.success) {
           const { success, data } = response;
            return {
                success,
                data
            }
        }   
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};

// unlike candidate
export async function unlike_candidate(data) {
    try {
        const response = await request('delete', '/person/unlike', {}, data);
        if (response.success) {
           const { success, data } = response;
            return {
                success,
                data
            }
        }   
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};

/* Person CV */

// load candidate cv
export async function loadCandidateCV(id) {
    try {
        const response = await request('get', `/person/${id}`, {});
        if (response.success) {           
            const { success, data } = response;        
            return {
                success,
                data: data.user
            }
        }   
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};


/* Profile */

// reset password
export async function changePassword(data) {
    try {
        const response = await request('put', `/change-password`, {}, data);
        if (response.success) {
            return {
                success: response.success
            }
        }
        
    } catch (err) {
        return {
            success: err.response.data.success,
            errorMessages: err.response.data.errorMessages
        }
    }
};

// edit profile data
export async function editProfileData(data) {
    try {
        const response = await request('put', `/company`, {}, data);
        if (response.success) {
            const { data, success } = response;
            removeState("user-data");
            saveState("user-data", data.user);

            return {
                data: data.user,
                success
            }
        }
        
    } catch (err) {
        return {
            success: err.response.data.success,
            errorMessages: err.response.data.errorMessages
        }
    }
};

// load profile data
export async function loadProfileData(id) {
    try {
        const response = await request('get', `/company/${id}`, {});
        if (response.success) {
            const { data, success } = response;
            removeState("user-data");
            saveState("user-data", data.user);

            return {
                data: data.user,
                success
            }
        }
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};

// edit profile picture
export async function editProfilePicture(data) {
    try {
        const response = await request('post', `/company/logo`, {'Content-Type': 'multipart/form-data'}, data);
        console.log('response: ', response);
        if (response.success) {
            const { data, success } = response;
            removeState("user-data");
            saveState("user-data", data.user);

            return {
                data: data.user,
                success
            }
        }
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};

// allow notifications push / email --> mobile
export async function allowNotifications(data) {
    try {
        const response = await request('post', `/settings`, {}, data);
        if (response.success) {
            const { success, data } = response;
            return {
                success,
                data: data.user
            }
        }
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};


/* Search */

export async function search_persons(searchQuery) {
    try {
        const response = await request('get', searchQuery, {});
        if (response.success) {
            const { success, data } = response;
            
            return {
                data: data.persons,
                success
            }
        }   
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};

export async function matching_algo(searchQuery) {
    try {
        const response = await request('get', searchQuery, {});
        if (response.success) {
            const { success, data } = response;
            
            return {
                data: data.persons,
                success
            }
        }   
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};
